import { createApp } from 'vue';
import { useRouter } from 'vue-router';
import router from './router'
import App from './App.vue';

const app = createApp(App);

app.use(router);
app.mount('#app');
// 初始页面
router.push('Home');
//router.push('UserDeviceManager');